import { action, payload } from "ts-action";
import * as AT from "./actionTypes";
import { BugModalInvoker, ErrorEntity } from "./types";

export const closeBugReportModal = action(AT.CLOSE_MODAL);
export const invokeBugReportModal = action(
  AT.INVOKE_MODAL,
  payload<{
    invoker: BugModalInvoker;
    error?: ErrorEntity;
    time: string;
  }>()
);

export const changeMessage = action(
  AT.CHANGE_MESSAGE,
  payload<{ message: string }>()
);

export const pushErrorToStack = action(
  AT.PUSH_ERROR_TO_STACK,
  payload<{ error: ErrorEntity }>()
);

export const removeErrorFromStack = action(
  AT.REMOVE_ERROR_TO_STACK,
  payload<{ index: number }>()
);

export const submitBugRequest = action(AT.SUBMIT_REPORT_REQUEST);
export const submitBugSuccess = action(AT.SUBMIT_REPORT_SUCCESS);
export const submitBugError = action(AT.SUBMIT_REPORT_ERROR);
